import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-button-navigation',
    templateUrl: './button-navigation.component.html',
    styleUrls: ['./button-navigation.component.scss'],
    standalone: false
})
export class ButtonNavigationComponent implements OnInit {
  @Input() type = 'two';
  @Input() readingMode = false;

  constructor() {}

  ngOnInit(): void {}
}
